import React from "react";

const BackgroundVideo = () => {
  return (
    <div className="video-container">
      <iframe
        src="https://www.youtube.com/embed/ykaWX35sUYI?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=ykaWX35sUYI"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Background Video"
        style={{
          width: "100%",
          height: "100vh",
          pointerEvents: "none", // disables clicking
        }}
      ></iframe>
    </div>
  );
};

export default BackgroundVideo;